import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Divider } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { HOME_ROUTE } from '../../../constants/routes';
import { simple } from '../../../config/paths';
import { useTicketStateBaseStyles } from './styles';
import { setIdType } from '../../../redux/slices/BreadcrumbsSlice';

const TicketStateBase = ({ ...props }) => {
  const { mobile, texts, image, returnText, simpleText } = props;
  const history = useHistory();
  const classes = useTicketStateBaseStyles({ mobile });
  const dispatch = useDispatch();

  const goToHome = () => {
    dispatch(setIdType(''));
    history.push(HOME_ROUTE);
  };
  const goToSimple = () => window.open(simple, '_blank');

  return (
    <Box className={classes.container}>
      <img src={image} className={classes.image} alt="" />
      <Box padding="0px 20px">{texts}</Box>
      <Divider className={classes.divider} />
      <Box className={classes.buttonContainer}>
        <Button
          variant="outlined"
          onClick={goToHome}
          className={classes.button}
        >
          {returnText}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={goToSimple}
          className={classes.button}
        >
          {simpleText}
        </Button>
      </Box>
    </Box>
  );
};

TicketStateBase.propTypes = {
  texts: PropTypes.element,
  image: PropTypes.string,
  returnText: PropTypes.string,
  simpleText: PropTypes.string,
  mobile: PropTypes.bool,
};

export default TicketStateBase;
